import Component from "../abstracts/Component";
import { isMobile, MobileBreakpoint } from "../utils/MobileUtils";
import FixBody from "../utils/FixBody";
import ajaxAction from "../utils/ajaxUtil";
import TrackingComponent from "../components/TrackingComponent";
import PriceRangeComponent from "../components/PriceRangeComponent";
import SaleRangeComponent from "../components/SaleRangeComponent";
import { getFocusElement, hasFocusElement } from "../utils/BrowserHistoryUtils";
import { trapFocusOnModal, removeTrapFocusOnModal } from "../utils/TrapFocus";

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      triggerBtn: "[data-trigger-filters]",
      filtersContainer: "[data-filters-container]",
      listItems: "[data-filters-item]",
      listItemsLabel: "[data-filters-item-label]",
      listItemActive: "[data-filters-item].active",
      liveSubItem: "[data-item-parent-name].live",
      subListPanel: "[data-sublist-container]",
      closeBtn: "[data-trigger-close]",
      closeBtnMobile: "[data-trigger-close-mobile]",
      ctaClear: "[data-cta-clear]",
      ctaView: "[data-cta-view]",
      benefitBar: "[data-benefit-bar]",
      itemText: "[data-item-text]",
      sublistTitle: "[data-sublist-title]",
      sublistText: "[data-sublist-text]",
      productsContainer: "[data-products-container]",
      allFiltersInputs: '[data-filters-item-label] input[type=checkbox]',
      filtersInputs: "[data-filter-input]",
      filtersInputsNoPrice:
        '[data-filter-input]:not([name="rangePriceFilter"])',
      priceFilterInputs: 'input[name="rangePriceFilter"]',
      filterSortBy: "[data-filter-sortby]",
      inputs: '.w-f__sublist__item input[type="checkbox"]',
      priceFilterMobile: "[data-mobile-price-filter]",
      priceMobileInputs: "[data-mobile-price-filter] input",
      priceMobileContainer: ".w-f__sublist.price-mobile",
      mobileResultsCount: "[data-mobile-results-count]",
      searchResultsCount: "[data-results-count]",
      saleRangeMobileInputs: "[data-mobile-sale-range-filter] input",
      saleRangeMobileContainer: ".w-f__sublist.sale-range-mobile",
      filters: ".w-filters",
      filtersCount: "[data-filters-count]",
      priceFilter: '.w-price-range',
      inSaleFilter: "[data-in-sale-filter]",
      //sort
      sortTrigger: "[data-trigger-sort]",
      sortContainer: "[data-sort-dropdown]",
      sortRadio: "[data-sort-radio]",
      closeSortMobile: "[data-trigger-close-sort-mobile]",
      sortLabel: "[data-sort-label]",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    // Remove hidden on w-filters when search results are empty
    let queryString = document.location.search;
    let filters = document.querySelectorAll(this.SELECTORS.filters);
    if (queryString.indexOf("isRefineSearch") != -1 && $(filters).hasClass("hidden")) {
      $(filters).removeClass("hidden");
    }
    this.selectedFiltersCount = 0; // Contatore dei filtri selezionati
    this.updateFilterCounter();
    this.listItems = this.$component.querySelectorAll(this.SELECTORS.listItems);
    this.subListPanel = this.$component.querySelector(
      this.SELECTORS.subListPanel,
    );
    this.triggerBtn = document.querySelector(this.SELECTORS.triggerBtn);
    this.sortTrigger = this.$component.querySelector(
      this.SELECTORS.sortTrigger,
    );
    //this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.closeBtnMobile = this.$component.querySelector(
      this.SELECTORS.closeBtnMobile,
    );
    this.filtersContainer = document.querySelector(
      this.SELECTORS.filtersContainer,
    );
    this.sortContainer = this.$component.querySelector(
      this.SELECTORS.sortContainer,
    );
    this.closeSortMobile = this.$component.querySelector(
      this.SELECTORS.closeSortMobile,
    );
    this.sortRadios = this.$component.querySelectorAll(
      this.SELECTORS.sortRadio,
    );
    this.sortLabels = this.$component.querySelectorAll(
      this.SELECTORS.sortLabel,
    );
    this.ctaClear = this.$component.querySelector(this.SELECTORS.ctaClear);
    this.ctaView = this.$component.querySelector(this.SELECTORS.ctaView);
    this.closeFilters = this.closeFilters.bind(this);

    // Trap focus properties
    this.filtersTrapHandler = null;
    this.handleFiltersEscape = this.handleFiltersEscape.bind(this);

    // Sort dropdown trap focus properties
    this.sortTrapHandler = null;
    this.handleSortEscape = this.handleSortEscape.bind(this);

    this.filtersInputs = document.querySelectorAll(
      this.SELECTORS.filtersInputs,
    );
    this.filtersInputsNoPrice = document.querySelectorAll(
      this.SELECTORS.filtersInputsNoPrice,
    );
    this.filterSortBy = document.querySelector(this.SELECTORS.filterSortBy);
    this.productsContainer = document.querySelector(
      this.SELECTORS.productsContainer,
    );
    this.qs = document.querySelector("[data-search-input]");
    this.mobileResultsCount = document.querySelector(
      this.SELECTORS.mobileResultsCount,
    );
    this.priceMobileContainer = document.querySelector(
      this.SELECTORS.priceMobileContainer,
    );
    this.filtersCounts = document.querySelectorAll(this.SELECTORS.filtersCount);
    // extra components
    this.trackingComponent = new TrackingComponent();
    this.PriceRangeComponent = new PriceRangeComponent(htmlEl);
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
    this.ajaxAction = new ajaxAction();
  }

  bindEvents() {
    let scrollY = 0;

    //check item label

    const labels = document.querySelectorAll("[data-filters-item-label]");

    labels.forEach((label) => {
      const toggleCheckbox = () => {
        const inputId = label.getAttribute("for");
        const input = document.getElementById(inputId);
        if (input && input.type === "checkbox" && !input.disabled) {
          input.checked = !input.checked;
        }
        // Update filters counter after toggling checkbox
        this.updateFiltersCounter();
      };
      // mouse click
      label.addEventListener("click", (e) => {
        e.preventDefault();
        toggleCheckbox();
      });
      // keyboard enter
      label.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          toggleCheckbox();
        }
      });
    });
    //end check item label

    //check if
    this.triggerBtn.addEventListener("click", () => {
      this.manageFiltersLayer();
    });

    this.ctaClear.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.resetFilters();
    });

    this.ctaView.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.applyFilters();
    });

    /*this.closeBtn.addEventListener('click', () => {
      this.closeFilters(scrollY);
    });*/

    this.closeBtnMobile.addEventListener("click", () => {
      this.closeFilters(scrollY);
    });

    this.closeSortMobile.addEventListener("click", () => {
      this.manageSortLayer();
    });

    this.handleSubnavRender();
    this.handleMenuItemClick();
    this.bindSalesLabel();
    this.bindMobilePrices();
    this.bindSorting();
    // this.bindMobileSaleRanges();
    this.$on(
      this.$customEvents.FILTERS_EVENTS.updated,
      ({ event, payload }) => {
        // Update filters counter
        this.updateFiltersCounter();
        // check if filters are available after filtering
        this.refreshFilters(payload.response);
        if (document.body.classList.contains("t-search")) {
          this.updateSearchResultsCount(payload.response);
        }
        if (isMobile(MobileBreakpoint.Max1023)) {
          this.refreshMobilePrices(payload.response);
          //updates mobile results count
          this.updateMobileResultsCount(payload.response);
        }
        this.updateFilterNav(payload.res);

        let newQs = payload.query.replace(this.QUERY_PARAMS.base() + "&", "?");
        history.replaceState(null, null, newQs);
      },
    );

    // Handle window resize to update tabindex on viewport change
    window.addEventListener('resize', () => {
      this.updateListItemsTabindex();
    });

    // dom ready
    $(document).ready(() => {
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      if (handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }

      this.updateFilterNav();
    });
  }

  timedOutScrollToElement($element) {
    setTimeout(() => {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element) {
    $element
      .get(0)
      .scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
  }

  closeFilters(scrollY) {
    this.filtersContainer.classList.remove("open");
    this.$component.classList.remove("open");
    if (isMobile(MobileBreakpoint.Max1023)) {
      FixBody.unblock(scrollY);
    }
    this.updateChevron(this.triggerBtn);
    this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    // Remove trap focus when closing filters
    this.removeFiltersTrapFocus();
  }

  // FILTERS TRAP FOCUS METHODS //
  handleFiltersEscape(e) {
    if (e.key === "Escape" && this.filtersContainer.classList.contains("open")) {
      this.closeFilters(0);
    }
  }

  applyFiltersTrapFocus() {
    if (this.filtersContainer) {
      this.filtersTrapHandler = trapFocusOnModal(this.filtersContainer);

      // Add escape key handler for filters
      document.addEventListener("keydown", this.handleFiltersEscape);
    }
  }

  removeFiltersTrapFocus() {
    if (this.filtersTrapHandler && this.filtersContainer) {
      removeTrapFocusOnModal(this.filtersContainer, this.filtersTrapHandler);
      this.filtersTrapHandler = null;

      // Remove escape key handler
      if (this.handleFiltersEscape) {
        document.removeEventListener("keydown", this.handleFiltersEscape);
      }
    }
  }

  // SORT DROPDOWN TRAP FOCUS METHODS //
  handleSortEscape(e) {
    if (e.key === "Escape" && this.sortContainer.classList.contains("open")) {
      this.manageSortLayer();
    }
  }

  applySortTrapFocus() {
    if (this.sortContainer) {
      this.sortTrapHandler = trapFocusOnModal(this.sortContainer);
      document.addEventListener("keydown", this.handleSortEscape);
    }
  }

  removeSortTrapFocus() {
    if (this.sortTrapHandler && this.sortContainer) {
      removeTrapFocusOnModal(this.sortContainer, this.sortTrapHandler);
      document.removeEventListener("keydown", this.handleSortEscape);
    }
  }

  updateFilterNav(res = false) {
    // update filters counter desktop
    this.manageFiltersCounter();
    // update checked sort
    this.manageSortSelection();

    if (res) {
      // update sort layer and mobile results count
      this.ajaxAction.renderContent(res, "mobile-results-count");
    }
  }

  bindSorting() {
    // layer close
    document.addEventListener("click", (e) => {
      if (
        !isMobile(MobileBreakpoint.Max1023) &&
        e.target !== this.sortTrigger &&
        !this.sortTrigger.contains(e.target) &&
        this.sortContainer.classList.contains("open")
      ) {
        this.manageSortLayer();
      }
    });

    this.sortTrigger.addEventListener("click", () => {
      this.manageSortLayer();
    });

    const onSortItemClick = (sort) => {
      this.filterSortBy.value = sort.value;
      // set checked sort for ui
      this.sortTrigger.dataset.currentSort = sort.value;
      // sort tracking
      this.trackingComponent.actions.filterTracking(sort, true);

      this.applyFilters(false, true);
      this.manageSortLayer();
    };


    this.sortLabels.forEach((label) => {
      label.addEventListener("click", (e) => {
        const selectedSort = e.target.previousElementSibling;
        onSortItemClick(selectedSort);
      });
      label.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          const selectedSort = e.target.previousElementSibling;
          onSortItemClick(selectedSort);
        }
      });
    });
  }

  updateListItemsTabindex() {
    const listItems = document.querySelectorAll(this.SELECTORS.listItems);
    listItems.forEach((listItem) => {
      const button = listItem.querySelector('button');

      if (!isMobile(MobileBreakpoint.Max1023)) {
        // Desktop viewport: button non-focusable
        if (button) button.setAttribute('tabindex', '-1');
      } else {
        // Mobile/tablet viewport: button is focusable
        if (button) button.removeAttribute('tabindex');
      }
    });
  }

  handleMenuItemClick() {
    const listItems = document.querySelectorAll(this.SELECTORS.listItems);
    this.cleanActiveMobileFilters();

    // Set initial tabindex based on current viewport
    this.updateListItemsTabindex();

    const activeItem = (itemIndex, { avoidMobile = false } = {}) => {
      this.cleanActiveMobileFilters();
      listItems.item(itemIndex).classList.add("active");
      this.$emit(this.$customEvents.FILTERS_EVENTS.active, avoidMobile);
    };

    listItems.forEach((listItem, index) => {
      listItem.addEventListener("click", (e) => {
        // Only handle clicks on mobile/tablet viewports, not on large viewports
        if (isMobile(MobileBreakpoint.Max1023)) {
          if (!e.target.classList.contains("active")) {
            activeItem(index);
          }
        }
      });
    });
  }

  cleanActiveMobileFilters() {
    document.querySelectorAll(this.SELECTORS.listItems).forEach((menuItem) => {
      menuItem.classList.remove("active");
    });
  }

  handleSubnavRender() {
    this.$on(
      this.$customEvents.FILTERS_EVENTS.active,
      ({ payload: avoidMobile = false }) => {
        const activeItem = document.querySelector(
          this.SELECTORS.listItemActive,
        );
        const sublistSelector = `[data-item-parent-name=${activeItem.dataset.filtersItem}]`;
        const sublistItems = document.querySelector(sublistSelector);
        this.elementEnter(
          sublistItems,
          document.querySelector(this.SELECTORS.liveSubItem),
        );

        if (!avoidMobile && isMobile(MobileBreakpoint.Max1023)) {
          const title = activeItem.querySelector(
            this.SELECTORS.itemText,
          ).innerHTML;
          this.setMobilePanel(title);
        }
      },
    );
  }

  elementEnter(
    elementEnter,
    elementExit,
    { destroy = false, goingOutEffect = "goingOut" } = {},
  ) {
    /**
     * Hide old menu
     */
    if (elementExit && elementExit.classList) {
      elementExit.classList.remove("live");
      elementExit.classList.add(goingOutEffect);
      setTimeout(() => {
        elementExit.classList.remove(goingOutEffect);
        if (destroy) {
          elementExit.remove();
        }
      }, 500);
    }

    /**
     * Show new menu
     */
    elementEnter.classList.add("live");
  }

  setMobilePanel(title) {
    const subListPanel = document.querySelector(this.SELECTORS.subListPanel);
    subListPanel.classList.add("open");
    subListPanel.querySelector(this.SELECTORS.sublistText).innerHTML = title;
    subListPanel
      .querySelector(this.SELECTORS.sublistTitle)
      .addEventListener("click", () => {
        subListPanel.classList.remove("open");
        this.cleanActiveMobileFilters();
      });
  }

  //END WIP

  get QUERY_PARAMS() {
    return {
      base: () => {
        if (document.body.classList.contains("t-search")) {
          return "?partial=true&save=false";
        }
        if(document.querySelector('.shortcut__item.selected')) {
          return '?save=false&';
        }
        return "?save=false";
      },
      // on shortcut category
      shortcut: () => {
        let shortcutQuery = '';
        let selectedShortcut = document.querySelector('.shortcut__item.selected');
        if (selectedShortcut && selectedShortcut.dataset.products != null) {
          let productsArray = selectedShortcut.dataset.products.split(',');
          productsArray.forEach((productCode) => {
            if (productCode.length === 13) {
              shortcutQuery += ':code:' + productCode;
            }
          });
        }
        return shortcutQuery;
      },
      pagination: (page) => {
        let paginationQueryBit = "";
        if (page) {
          // currentPage
          paginationQueryBit = "&page=" + page;
        }
        // if not cached
        return paginationQueryBit;
      },
      textSearch: () => {
        // on search page
        if (document.body.classList.contains("t-search")) {
          // other catches
          if (typeof this.qs == "undefined" || this.qs == null) return;
          if (typeof this.qs.getAttribute("value") != null) {
            let q = this.qs.getAttribute("value");
            let matchString = new RegExp("[^:]*", "");
            let search = q.match(matchString);
            return search[0];
          }
        }
        return "";
      },
      sortBy: (qs = false) => {
        // if there is no sort, exit
        if (
          typeof this.filterSortBy == "undefined" ||
          this.filterSortBy == null
        )
          return;
        let sort = this.filterSortBy.value;

        // return the sort
        if (qs) {
          return "&sort=" + sort + ":";
        } else {
          return ":" + sort;
        }
      },
      priceRange: (isReset) => {
        let priceQuery = this.PriceRangeComponent.buildQuery(isReset);
        return priceQuery;
      },
      saleRange: () => {
        let saleRangeQuery = this.SaleRangeComponent.buildQuery();
        return saleRangeQuery;
      },
      formData: (fromSortBy = false) => {
        // query
        let filterQuery = "";
        let isSales = false;
        // form inputs
        document
          .querySelectorAll(this.SELECTORS.filtersInputsNoPrice)
          .forEach((input) => {
            if (input.checked) {
              if (input.id.indexOf("inSales") !== -1) {
                isSales = true;
                //tracking
                if (!fromSortBy)
                  this.trackingComponent.actions.filterTracking(
                    input.name,
                    input.value,
                  );
              }
              filterQuery = filterQuery + ":" + input.name + ":" + input.value;
              //tracking
              if (!fromSortBy)
                this.trackingComponent.actions.filterTracking(
                  input.name,
                  input.value,
                );
              if (isSales == false) {
                filterQuery.replace("inSales:true:", "");
              }
            }
          });
        return filterQuery;
      },
    };
  }

  // build the filters
  buildQuery(page = false, isReset, fromSortBy = false) {
    // get full query
    let fullQuery =
      this.QUERY_PARAMS.base() +
      "&isRefineSearch=" +
      this.hasActiveFilters() +
      "&q=" +
      this.QUERY_PARAMS.textSearch() +
      this.QUERY_PARAMS.sortBy() +
      this.QUERY_PARAMS.shortcut() +
      this.QUERY_PARAMS.priceRange(isReset) +
      this.QUERY_PARAMS.saleRange() +
      this.QUERY_PARAMS.formData(fromSortBy) +
      this.QUERY_PARAMS.pagination(page);

    this.log("fullQuery ", fullQuery);
    return fullQuery;
  }

  // filter function
  filterQuery(page, query = "", isReset = false, fromSortBy = false) {
    this.log("launch query");
    // build the query
    if (query === "") {
      query = this.buildQuery(page, isReset, fromSortBy);
    }
    // main products container
    let productsContainer = this.productsContainer;
    // get the page
    this.getFilteredPage(query).then((res) => {
      // render the page
      this.renderPage(res, productsContainer, query, isReset);
    });
  }

  // get page via ajax function
  getFilteredPage(query) {
    // get content
    return this.ajaxAction.getPage(query);
  }

  // render results
  renderPage(res, target, query = false, isReset = false) {
    // html response
    let response = new DOMParser().parseFromString(res, "text/html");
    // render content
    this.ajaxAction.renderContent(res, "products");
    if (isReset) {
      this.ajaxAction.renderContent(res, "filters-list");
      this.ajaxAction.renderContent(res, "filters-sublist");
      this.ajaxAction.renderContent(res, "product-count");
      // hide remove filters buttons
      this.hideFilteredElements();
      let newRanger = document.querySelector(
        this.PriceRangeComponent.SELECTORS.rangerBar,
      );
      // is priceFilter present
      try {
        if (
          newRanger != null &&
          !this.PriceRangeComponent.readDOM().rangeSlider.noUiSlider
        ) {
          let newSliderLogic = new PriceRangeComponent(newRanger);
          newSliderLogic.renderNewSlider();
        }
      } catch (e) {
        console.warn(e);
      }
      this.handleMenuItemClick();
      this.updateFilterCounter();
      this.subListPanel = this.$component.querySelector(
        this.SELECTORS.subListPanel,
      );
      if (this.subListPanel) {
        this.subListPanel.classList.remove("open");
      }
    }

    // emit events
    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
    this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
      response: response,
      res: res,
      query: query
    });
    // scroll to top
    window.scrollTo(0, 0);
  }

  // apply function
  applyFilters(isReset = false, fromSortBy = false) {
    // creates and launches query
    this.filterQuery(false, "", isReset, fromSortBy);
  }

  // reset function
  resetFilters() {
    // cycle desktop inputs
    document.querySelectorAll(this.SELECTORS.inputs).forEach((input) => {
      // set input false
      if (input.checked === true) {
        input.checked = false;
      }
    });

    // reset sliders
    this.PriceRangeComponent.resetSlider();
    // launch void query
    this.filterQuery(false, "", true);
  }

  hasActiveFilters(getFiltersCount = false) {
    let isAnyActive = false;
    let activeFiltersCount = 0;

    document.querySelectorAll(this.SELECTORS.filtersInputs).forEach((input) => {
      if (input.checked) {
        isAnyActive = true;
        activeFiltersCount++;
      }
    });
    // check price for desktop, needs query on document to find slider values
    if (
      this.PriceRangeComponent.isSliderChanged(
        this.PriceRangeComponent.readDOM().rangeSlider
      )
    ) {
      isAnyActive = true;
      activeFiltersCount++;
    }

    if (getFiltersCount && activeFiltersCount > 0) {
      return activeFiltersCount;
    }

    return isAnyActive;
  }

  manageFiltersCounter() {
    try {
      this.filtersCounts.forEach((count) => {
        if (count != null) {
          if (this.hasActiveFilters(false)) {
            count.innerHTML = " (" + this.hasActiveFilters(true) + ")";
          }
        }
      });
    } catch (e) {
      console.warn("Filters counter failed to render.");
    }
  }

  hideFilteredElements() {
    this.triggerBtn.querySelector(".active-filters") != null
      ? (this.triggerBtn.querySelector(".active-filters").innerHTML = "")
      : "";
  }

  refreshFilters(response) {
    document
      .querySelectorAll(this.SELECTORS.filtersInputsNoPrice)
      .forEach((input) => {
        if (
          response.querySelector("#" + CSS.escape(input.id)) == null &&
          !input.checked
        ) {
          input.parentElement.classList.add("unavailable");
          input.disabled = true;
        } else {
          input.parentElement.classList.remove("unavailable");
          input.disabled = false;
        }
      });
    // refresh price filters
    document
      .querySelectorAll(this.SELECTORS.priceFilterInputs)
      .forEach((input) => {
        if (input.checked) {
          if (response.querySelector("#" + CSS.escape(input.id)) != null) {
            response.querySelector("#" + CSS.escape(input.id)).checked = true;
          }
        }
      });
    this.bindSalesLabel();
  }

  setMobilePrices(input) {
    if (input.checked) {
      let range = input.dataset.value.split("|");
      document.querySelector(".w-price-range [data-input-min]").value =
        range[0];
      if (range[1] != "") {
        document.querySelector(".w-price-range [data-input-max]").value =
          range[1];
      }
    } else {
      document.querySelector(".w-price-range [data-input-min]").value = "";
      document.querySelector(".w-price-range [data-input-max]").value = "";
    }
  }

  // clear the mobile prices given the selected one
  cleanOtherMobilePrices(selectedInput) {
    document
      .querySelectorAll(this.SELECTORS.priceMobileInputs)
      .forEach((input) => {
        if (input.id !== selectedInput.id) {
          input.checked = false;
        }
      });
    if (document.querySelector(this.SELECTORS.inSaleFilter)) {
      this.refreshSalesFilterMobile();
    }
  }

  // refresh the mobile prices on update filters event
  refreshMobilePrices(response) {
    if (response.querySelector(this.SELECTORS.priceMobileContainer) != null) {
      let newPriceRanges = response.querySelector(
        this.SELECTORS.priceMobileContainer,
      ).innerHTML;
      if (this.priceMobileContainer.innerHTML !== newPriceRanges) {
        this.priceMobileContainer.innerHTML = newPriceRanges;
        this.bindMobilePrices();
        if (document.querySelector(this.SELECTORS.inSaleFilter)) {
          this.refreshSalesFilterMobile(true);
        }
      }
    }
  }

  // update mobile products counter
  updateMobileResultsCount(response) {
    if (response.querySelector(this.SELECTORS.searchResultsCount) != null) {
      // new count from the ajax response
      let newCount = response.querySelector(
        this.SELECTORS.mobileResultsCount,
      ).innerHTML;
      // insert count in mobile layer
      this.mobileResultsCount.innerHTML = newCount;
    }
  }

  updateFilterCounter() {
    document.querySelectorAll(this.SELECTORS.allFiltersInputs).forEach(input => {
      input.addEventListener('click', (e) => {
        if (e.target.matches(this.SELECTORS.filtersInputs))
          this.updateFiltersCounter();
      });
    });
  }

  updateFiltersCounter() {
    const inputs = document.querySelectorAll(this.SELECTORS.allFiltersInputs + ":checked");
    const isPriceFilterActive = document.querySelector(this.SELECTORS.priceFilter)?.classList.contains('c-p-r__max-value-set') || document.querySelector(this.SELECTORS.priceFilter)?.classList.contains('c-p-r__min-value-set');
    let uniqueIds = new Set();
    //remove possible doubles as "inSalesFilterMobile" && "inSales-true" or "newArrivalFilterMobile" && "newArrival-true"
    inputs.forEach(input => {
      const normalizedId = input.id.replace(/(FilterMobile|-true)/g, '');
      uniqueIds.add(normalizedId);
    });
    this.selectedFiltersCount = uniqueIds.size + (isPriceFilterActive ? 1 : 0);

    let titleFilterCounterElements = document.querySelectorAll(this.SELECTORS.filtersCount);
    if (titleFilterCounterElements) {
      if(this.selectedFiltersCount) {
        titleFilterCounterElements.forEach(title => {
          title.textContent = '(' + this.selectedFiltersCount + ')';
        });
      }
      else {
        titleFilterCounterElements.forEach(title => {
          title.textContent = '';
        });
      }
    }
  }

  // bind the mobile click to the desktop filter
  bindMobilePrices() {
    document
      .querySelectorAll(this.SELECTORS.priceFilterMobile)
      .forEach((priceFilterMobile) => {
        priceFilterMobile.addEventListener("click", () => {
          //binds main sales filter
          let input = priceFilterMobile.querySelector("input");
          if (input.id === "inSalesFilterMobile") {
            const salesFilter = document.querySelector(this.SELECTORS.inSalesFilter);
            if (salesFilter) {
              salesFilter.checked = input.checked;
            }
            this.PriceRangeComponent.resetSlider();
          } else {
            //sets price range in price slider for main logic
            this.setMobilePrices(input);
            //only one price range can be active
          }
          this.cleanOtherMobilePrices(input);
          this.updateFiltersCounter();
        });
      });
  }

  manageFiltersLayer() {
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    let filtersContainer = this.filtersContainer != null ? this.filtersContainer : document.querySelector(this.SELECTORS.filtersContainer);
    if (filtersContainer.classList.contains("open")) {
      this.closeFilters(scrollY);
    } else {
      filtersContainer.classList.add("open");
      this.updateChevron(this.triggerBtn, true);
       if(!isMobile(MobileBreakpoint.Max1023)) {
          filtersContainer.style.height = this.contentHeight + 'px';
          // Close sorting dropdown if filters overlay is open
          if(this.sortTrigger.classList.contains('open')) {
            this.sortTrigger.classList.remove('open');
          }
        } else {
          scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
          FixBody.block(barHeight);
        }
      // Apply trap focus when opening filters
      this.applyFiltersTrapFocus();
      this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
    }
  }

  manageSortLayer() {
    // toggles filter layer
    const isLayerOpen = this.sortContainer.classList.contains("open");

    // mobile logic
    if (isMobile(MobileBreakpoint.Max1023)) {
      if (isLayerOpen) {
        FixBody.unblock(scrollY);
      } else {
        let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
        let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
        scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
        FixBody.block(barHeight);
      }
    }

    if (isLayerOpen) {
      this.sortContainer.classList.remove("open");
      this.sortLabels.forEach((label) => {
        label.tabIndex = -1;
      });
      this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
      // Remove trap focus when closing sort dropdown
      this.removeSortTrapFocus();
    } else {
      this.sortContainer.classList.add("open");
      this.sortLabels.forEach((label) => {
        label.tabIndex = 0;
      });
      if (this.filtersContainer.classList.contains("open")) {
        this.closeFilters(scrollY);
      }
      this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      // Apply trap focus when opening sort dropdown
      this.applySortTrapFocus();
    }
    this.updateChevron(this.sortTrigger, !isLayerOpen);
  }

  manageSortSelection() {
    const currentSort = this.sortTrigger.dataset.currentSort;

    this.sortRadios.forEach((radio) => {
      if (radio.id === currentSort) {
        radio.checked = true;
      }
    });
  }

  updateChevron(parent, isOpened = false) {
    // update chevron for filter and sort triggers in nav
    try {
      parent.querySelector("[data-chevron-open]").style.display = isOpened
        ? "block"
        : "none";
      parent.querySelector("[data-chevron-close]").style.display = isOpened
        ? "none"
        : "block";
    } catch (e) {
      console.warn("Chevron not found");
    }
  }

  // refresh the sale filter mobile trigger
  refreshSalesFilterMobile(isResponse) {
    let mobileSalesFilter = document.querySelector("#inSalesFilterMobile");
    let mainSalesFilter = document.querySelector(this.SELECTORS.inSaleFilter);
    if (mobileSalesFilter != null && mainSalesFilter != null) {
      if (isResponse) {
        if (mainSalesFilter.checked) {
          mobileSalesFilter.checked = true;
        } else {
          mobileSalesFilter.checked = false;
        }
      } else {
        if (mobileSalesFilter.checked) {
          mainSalesFilter.checked = true;
        } else {
          mainSalesFilter.checked = false;
        }
      }
    }
  }

  // sales label in mobile
  bindSalesLabel() {
    if (document.querySelector(".sales-label") != null) {
      document.querySelector(".sales-label").addEventListener("click", () => {
        let salesInput = document.querySelector(this.SELECTORS.inSaleFilter);
        if (salesInput) {
          salesInput.checked = !salesInput.checked;
        }
      });
    }
  }

  // update products counter
  updateSearchResultsCount(response) {
    const respSearchResultsCount = response.querySelector(
      this.SELECTORS.searchResultsCount,
    );
    const pageSearchResultsCount = document.querySelector(
      this.SELECTORS.searchResultsCount,
    );

    if (respSearchResultsCount != null && pageSearchResultsCount != null) {
      pageSearchResultsCount.innerHTML = respSearchResultsCount.innerHTML;
    }
  }

  ////////////////////////////
  //  // sale range mobile filter
  //  // bind the mobile click to the desktop filter
  //  bindMobileSaleRanges() {
  //    document.querySelectorAll(this.SELECTORS.saleRangeMobileInputs).forEach(input => {
  //      input.addEventListener('click', () => {
  //        // sets sale range in sale range slider for main logic
  //        this.setSaleRangeFromMobile(input);
  //        // only one sale range can be active
  //        this.cleanSaleRangeInputs(input);
  //      });
  //    });
  //  }
  //  // set values on desktop sale range slider
  //  setSaleRangeFromMobile(input) {
  //    if(input.checked) {
  //      let range = input.dataset.value.split("|");
  //      // set min val
  //      document.querySelector('.w-sale-range [data-input-min]').value = range[0];
  //      if(range[1] != '') {
  //        // set max val
  //        document.querySelector('.w-sale-range [data-input-max]').value = range[1];
  //      }
  //    } else {
  //      // reset values
  //      document.querySelector('.w-sale-range [data-input-min]').value = '';
  //      document.querySelector('.w-sale-range [data-input-max]').value = '';
  //    }
  //  }
  //
  //  // clear the mobile prices given the selected one
  //  cleanSaleRangeInputs(selectedInput) {
  //    document.querySelectorAll(this.SELECTORS.saleRangeMobileInputs).forEach(input => {
  //      if(input.id !== selectedInput.id) {
  //        input.checked = false;
  //      }
  //    });
  //  }

  render() {
    super.render();
    this.bindEvents();
  }
}
